<template>
  <div class="index">
    <div class="live__box">
      <!-- 直播/点播 标题 -->
      <div v-for="(item, index) in awardList" :key="index">
        <div v-if="item.body.type == 1">
          <div class="tit__liveVideo" v-if="awardLiveInfo.title_image">
            <img :src="awardLiveInfo.title_image">
          </div>
          <!-- 直播 -->
          <div class="tit__liveVideo">
            <p v-if="awardLiveShow">{{awardLiveInfo.content}}</p>
          </div>
          <div class="activ__liveBox" :style="'display:' + (!awardLiveShow ? 'none;' : 'block;')">
              <!-- <button class="btn__videoStart" v-if="!awardLivePlay" @click="awardLiveDoPlay()">播放</button> -->
              <!-- <div id="flash_video" :style="'display:' + (!awardLivePlay ? 'none;' : 'block;')"></div> -->
              <!-- <img :src="awardLiveInfo.image" :style="'display:' + (awardLivePlay ? 'none;' : 'block;')"> -->

              <div id="flash_video"></div>
          </div>
        </div>

        <!-- 点播 -->
        <div v-if="item.body.type == 2">
          <div class="tit__liveVideo" v-if="awardVideoInfo.title_image">
            <img :src="awardVideoInfo.title_image">
          </div>
          <div class="tit__liveVideo">
            <p v-if="awardVideoShow">{{awardVideoInfo.content}}</p>
          </div>
          <div class="activ__videoBox" :style="'display:' + (!awardVideoList.length > 0 ? 'none;' : 'block;')">
            <div class="videobox">
              <button class="btn__videoStart" v-if="!awardVideoPlay" @click="awardVideoDoPlay()">播放</button>
              <video ref="awardVideo" src="" controls :style="'display:' + (!awardVideoPlay ? 'none;' : 'block;')" ></video>
              <img :src="awardVideoItemInfo.image" :style="'display:' + (awardVideoPlay ? 'none;' : 'block;')">
            </div>
            <div class="activ__videoTab">
                <div id="swiper__videoTab" class="swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in awardVideoList" :key="index">
                      <div class="swiper__videoTab__box">
                        <img v-lazy="item.body.image" />
                      </div>
                      <p>{{item.body.title}}</p>
                  </div>
              </div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
            </div>
          </div>
        </div>

        <div v-if="item.body.type == 3">
        <div class="tit__liveVideo" v-if="awardPicInfo.title_image">
          <img :src="awardPicInfo.title_image">
        </div>
          <!-- 图片 -->
          <div class="tit__liveVideo">
            <p v-if="awardPicShow">{{awardPicInfo.content}}</p>
          </div>
          <div class="activ__imageBox" :style="'display:' + (!awardPicShow ? 'none;' : 'block;')">
              <!-- <button class="btn__videoStart">播放</button> -->
              <img v-lazy="awardPicInfo.image">
          </div>
        </div>
      </div>
    </div>
    <div class="inner">
      <!-- 大会介绍 -->
      <div class="activ__rule" style="margin-top: 1.25rem;">
        <h4>大会介绍</h4>
        <p class="center">一国、一域、一城、一馆、一物、一峥嵘！</p>
        <p>
          “博潮”首届博物馆青年文创联名大会暨十二生肖文物创意联名设计大会，由中国文物报社主办，
          央视网、好品中国品牌建设办公室联合主办，以 2021
          年中国生肖“牛”为设计主题，面向全国青年设计爱好者以及相关院校学生征集优秀作品。报名选手将依据40余家文博机构提供的含有“丑牛”相关元素的文物和藏品进行作品设计和评选，并举办颁奖仪式及主题论坛，让中国传统文化的价值融于创新并应用于生活。
        </p>
        <p>
          如何用新的创新方式，讲记载着厚重历史文化韵味的文物，顺应时代的潮流，通过设计之笔，让文物活起来，融入现代人文生活之中？如果你拥有奇思妙想的灵感、出神入化的画笔、和一颗炽热的华夏之心，就带上你的创意Idea来加入博潮文创设计大会吧！
        </p>
      </div>

      <!-- 时间点 -->
      <div class="activ__time">
        <div class="activ__step step1">选手报名<br />并上传作品</div>
        <div class="activ__step step2">初评<br />公示入围作品</div>
        <div class="line"></div>
        <div class="activ__step step3">专家评选</div>
        <div class="activ__step step4 current">颁奖典礼</div>
      </div>
      <!-- 获奖名单 -->
      <div class="tit__shortlist tit__shortlist1">获奖名单</div>
      <div class="activ__shortlist">  
          <p class="activ__rec">“博潮”首届博物馆青年文创联名大会（十二生肖文物创意联名设计大会）活动自2020年11月启动以来，受到社会各界的广泛关注，至截止日期共征集作品313件，涵盖视觉设计、多媒体、交互设计、文创产品及旅游商品设计等类别，涉及艺术品、家具、服饰、首饰、刺绣、益智玩具等产品形式，设计作品和“丑牛”主题元素巧妙融合，在传统文化的基础上大胆创新，风格独特且实用美观。</p>

          <p class="activ__rec">本次终评采用现场评审方式，本着公平、公正、公开的原则，由博物馆、美术馆、设计师、文化产业管理等相关领域的行业专家担任评委，对入围作品的文化性、市场前景、实用与审美、创新性等多个层面进行终极考量。来自不同领域的专家各抒己见，从不同角度推选优秀设计作品，为博潮文创增添了新的内涵。</p>
          <h3>“博潮”首届博物馆青年文创联名大会获奖名单</h3>
          <h4><span>___</span> {{levelInfo[157016].body.title}} <span>___</span> </h4>
          <table class="shortlist__box">
              <tr>
                <th class="award">奖别</th>
                <th class="name">作品名称</th>
                <th class="type">作品类型</th>
                <th class="author">作者名字</th>
              </tr>
              <tr v-for="(info, key) in levelList[157016]" v-bind:key="key">
                <td class="award">{{ info.body.prize }}</td>
                <td class="name"><em></em><div class="text"><p>{{ info.body.title }}</p></div><em></em></td>
                <td class="type">{{ info.body.category }}</td>
                <td class="author author1"><div class="text"><p>{{ info.body.name }}</p></div></td>
              </tr>
          </table>

          <h4><span>___</span> {{levelInfo[157017].body.title}} <span>___</span> </h4>
          <table class="shortlist__box">
              <tr>
                <th class="award">奖别</th>
                <th class="name">作品名称</th>
                <th class="type">作品类型</th>
                <th class="author">企业名称</th>
              </tr>
              <tr v-for="(info, key) in levelList[157017]" v-bind:key="key">
                <td class="award">{{ info.body.prize }}</td>
                <td class="name"><em></em><div class="text"><p>{{ info.body.title }}</p></div><em></em></td>
                <td class="type">{{ info.body.category }}</td>
                <td class="author author1"><div class="text"><p>{{ info.body.name }}</p></div></td>
              </tr>
          </table>
          <div class="tip"></div>
          <!-- <div class="tip">获奖作品图后续更新呈现，请大家持续关注！感谢对本届博潮文创大会的支持！</div> -->
          <div class="shortlist__footBlank"></div>
      </div>

      <!-- 入围名单 -->
      <!-- <div class="tit__shortlist">入围名单<div class="tit__shortlistTip">（ 排名无先后 ）</div></div>
      <div class="activ__shortlist">  
          <h4><span>___</span>【A类】视觉设计、多媒体、交互设计类 <span>___</span> </h4>
          <table class="shortlist__box">
              <tr>
                <th class="name">作品名称</th>
                <th class="author">作者名字</th>
                <th class="tel">作者电话</th>
              </tr>
              <tr v-for="(info, key) in levelList[156637]" v-bind:key="key">
                <td class="name"><em></em><div class="text"><p>{{ info.body.title }}</p></div><em></em></td>
                <td class="author"><div class="text"><p>{{ info.body.name }}</p></div></td>
                <td class="tel">{{ info.body.phone }}</td>
              </tr>
          </table>
          <div class="shortlist__foot">
            <div class="btn__fold" @click="open(156637)"><span v-if="!levelOpen[156637]">点击展开</span><span v-else>点击收起</span><em v-if="!levelOpen[156637]"></em><em v-else class="folded"></em></div>
          </div>

          <h4><span>___</span>【B类】文创产品及旅游商品设计类 <span>___</span> </h4>
          <table class="shortlist__box">
              <tr>
                <th class="name">作品名称</th>
                <th class="author">作者名字</th>
                <th class="tel">作者电话</th>
              </tr>
              <tr v-for="(info, key) in levelList[156638]" v-bind:key="key">
                <td class="name"><em></em><div class="text"><p>{{ info.body.title }}</p></div><em></em></td>
                <td class="author"><div class="text"><p>{{ info.body.name }}</p></div></td>
                <td class="tel">{{ info.body.phone }}</td>
              </tr>
          </table>
          <div class="shortlist__foot">
            <div class="btn__fold" @click="open(156638)"><span v-if="!levelOpen[156638]">点击展开</span><span v-else>点击收起</span><em v-if="!levelOpen[156638]"></em><em v-else class="folded"></em></div>
          </div>
          <div class="shortlist__footBlank"></div>
      </div> -->

      <!-- 权威博物馆鼎力支持 -->
      <div class="activ__apply clearfix">
        <div class="apply__box" v-for="(info, key) in museumList" v-bind:key="key">
          <a :href="'list.html?title=' + info.body.title + '&id=' + info.id">
            <img v-lazy="info.body.image" />
          </a>
          <p>{{ info.body.title }}</p>
        </div>
      </div>
      <!-- 跳转banner -->
      <div class="active__banner">
        <a href="show.html"><img src="../../statics/img/banner2.png"></a>
      </div>

      <!-- <div class="live__box">
        <div v-for="(item, index) in awardList" :key="index">
          <div v-if="item.body.type == 2">
            <div class="tit__liveVideo" v-if="awardVideoInfo.title_image">
              <img :src="awardVideoInfo.title_image">
            </div>
            <div class="tit__liveVideo">
              <p v-if="awardVideoShow">{{awardVideoInfo.content}}</p>
            </div>
            <div class="activ__videoBox" :style="'display:' + (!awardVideoList.length > 0 ? 'none;' : 'block;')">
              <div class="videobox">
                <button class="btn__videoStart" v-if="!awardVideoPlay" @click="awardVideoDoPlay()">播放</button>
                <video ref="awardVideo" src="" controls :style="'display:' + (!awardVideoPlay ? 'none;' : 'block;')" ></video>
                <img :src="awardVideoItemInfo.image" :style="'display:' + (awardVideoPlay ? 'none;' : 'block;')">
              </div>
              <div class="activ__videoTab">
                  <div id="swiper__videoTab" class="swiper-container">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="(item, index) in awardVideoList" :key="index">
                        <div class="swiper__videoTab__box">
                          <img v-lazy="item.body.image" />
                        </div>
                        <p>{{item.body.title}}</p>
                    </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="live__box">
        <div v-for="(item, index) in awardList2" :key="index">
          <div v-if="item.body.type == 2">
            <div class="tit__liveVideo" v-if="awardVideoInfo2.title_image">
              <!-- <img src="../../statics/img/title9.png"> -->
              <img :src="awardVideoInfo2.title_image">
            </div>
            <!-- 点播 -->
            <div class="tit__liveVideo">
              <p v-if="awardVideoShow2">{{awardVideoInfo2.content}}</p>
            </div>
            <div class="activ__videoBox" :style="'display:' + (!awardVideoList2.length > 0 ? 'none;' : 'block;')">
              <div class="videobox">
                <button class="btn__videoStart" v-if="!awardVideoPlay2" @click="awardVideoDoPlay2()">播放</button>
                <video ref="awardVideo2" src="" controls :style="'display:' + (!awardVideoPlay2 ? 'none;' : 'block;')" ></video>
                <img :src="awardVideoItemInfo2.image" :style="'display:' + (awardVideoPlay2 ? 'none;' : 'block;')">
              </div>
              <!-- 点播切换列表 -->
              <div class="activ__videoTab">
                  <div id="swiper__videoTab2" class="swiper-container">
                    <div class="swiper-wrapper">
                    <!-- swiper-slide 选中增加 active -->
                      <div class="swiper-slide" v-for="(item, index) in awardVideoList2" :key="index">
                        <div class="swiper__videoTab__box">
                          <img v-lazy="item.body.image" />
                        </div>
                        <p>{{item.body.title}}</p>
                    </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 瞬间中国 -->
      <div class="tit__seek">寻找2020最“牛”瞬间</div>
      <div class="activ__rule">
        <p>
          2020年注定是不同寻常的一年，其中一定有某一个瞬间让你记忆深刻，触动灵魂。在辛丑牛年即将到来之际，“博潮”文创大会携手《瞬间中国》栏目，邀你“牛”转乾坤。进入“瞬间中国”微博号、抖音号，“博潮文创大会”微博号，一句话讲述你的2020最“牛”瞬间。
        </p>
      </div>
      <div class="activ__video clearfix">
          <div class="video__list" v-for="(item, index) in momentList" :key="index">
            <!-- <img src="https://img.itv.cctvpic.com/itv/cms/2020/10/29/74fb25a03041c394f6662bc9b0c6e236.jpg"/> -->
            <div class="video__cover">
            <button class="btn__play" @click="show(index)"></button>
            <img v-lazy="item.body.image" @click="show(index)" />
            </div>
            <p class="video__name" @click="show(index)">
              <!-- 博物院展品博物院展品博物院展品博物院展品博物院展品博物院展品博物院展品 -->
              {{ item.body.title }}
            </p>
          </div>
      </div>

    </div>
    <!-- inner end  -->
    <div class="inner">
      <!-- 投票标题 -->
      <div class="tit__note">为您喜欢的展品投票</div>
      <div class="activ__rule">
        <a class="link__rank" href="rank.html">排行榜</a>
        <p>
          丑时春入户,
          牛岁福临门。在牛年新春即将到来之际，中国文物报社面向全国各文博单位征集生肖牛文物，邀请您来投票，选出“2021年百姓最喜爱的十件牛文物”。
        </p>
        <p>
          投票截止时间：12月20日
        </p>
      </div>
    </div>
    <!-- inner end  -->
    <!-- 投票 -->
    <div class="bg__color">
      <div class="activ__note">
        <div id="swiper__note" class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in exhibitsList" :key="index">
              <!-- <img src="https://img.itv.cctvpic.com/itv/cms/2020/10/23/2458c2f7e1dd8ec57ac9f89b968f9216.jpg" /> -->
              <img v-lazy="item.body.image" />
              <p class="note__name">
                <!-- {{ index }} -->
                {{ item.body.title }}
              </p>
              <!-- <button class="btn__noted" v-if="item.isVote">已投票</button>
              <button class="btn__note" v-else @click="vote(item.id, index)">投 票</button> -->
              <span class="lab__count"><span>{{item.voteNum}}</span>票</span>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 投票 end -->
    <!-- activ__note end -->

    <div class="inner">
      <!-- “云”游博物馆 -->
      <div class="tit__look" v-if="cloudList.length > 0">“云”游博物馆</div>
      <div class="activ__video video__five clearfix">
          <div class="video__list" v-for="(item, index) in cloudList" :key="index">
            <div class="video__cover">
            <button class="btn__play" @click="show(index, 2)"></button>
            <img v-lazy="item.body.image" @click="show(index, 2)" />
            </div>
            <p class="video__name" @click="show(index, 2)">
              {{ item.body.title }}
            </p>
          </div>
      </div>

      <!-- “云”讲文物 -->
      <div class="tit__speak" v-if="relicList.length > 0">“云”讲文物</div>
      <div class="activ__video video__five clearfix">
          <div class="video__list" v-for="(item, index) in relicList" :key="index">
            <div class="video__cover">
            <button class="btn__play" @click="show(index, 3)"></button>
            <img v-lazy="item.body.image" @click="show(index, 3)" />
            </div>
            <p class="video__name" @click="show(index, 3)">
              {{ item.body.title }}
            </p>
          </div>
      </div>

    </div>
    
    <!-- 二维码 -->
    <div class="fixed">
      <div class="fixed__share clearfix" :style="'display:' + (isMobile() ? 'none;' : 'block;')">
        <div class="share shareWX" @click="wxShare()">微信</div>
        <!-- <div class="share shareSina">微博</div> -->
        <div class="share shareQQ" @click="qqShare()">QQ</div>
        <div class="share shareQzone" @click="qzoneShare()">空间</div>
        <!-- 微信分享浮层   style="display:none"-->
        <div class="fixed__code codeWX" :style="'display:' + wxShareDispaly">
          <img src="@/statics/img/wxShareCode.png" />
          <p>微信扫码</p>
        </div>
      </div>
      <div class="fixed__code code1">
        <img src="@/statics/img/code.jpg" />
        <p>个人及社会团体组<br />扫码报名</p>
      </div>
      <div class="fixed__code code2">
        <img src="@/statics/img/qycode.jpg" />
        <p>企业品牌合作组<br />扫码报名</p>
      </div>
    </div>
    <!-- fixed end -->

    <!-- 空白内容 -->
    <div class="blank"></div>
    
    <!-- 视频弹出窗 -->
    <div class="modal">
        <div class="btn__close" @click="close()">关闭</div>
        <div class="swiper__container">
            <video ref="video" class="modal__video" src="" controls webkit-playsinline="true" x5-video-player-type="h5" x5-video-orientation="portraint"></video>
          </div>
    </div>    
  </div>
  
</template>

<script>
// import Swiper from "swiper/swiper-bundle.esm.browser";
// import "swiper/swiper-bundle.css";

import { isMobile } from '@/utils/utils'
import { getUrlParam } from '@/utils/utils'

export default {
  data() {
    return {
      scene: 0,
      museumList: [],
      exhibitsList: [],
      momentList: [],
      cloudList: [],
      relicList: [],
      levelList: {},
      levelInfo: {
        157016: {body: {title: ""}},
        157017: {body: {title: ""}}
      },
      levelShortList: {},
      levelLongList: {},
      levelOpen: {
        156637: true,
        156638: true,
      },
      levelShortNum: 10,
      video: {},
      videoIndex: 0,
      wxShareDispaly: "none;",
      awardList: [],
      awardPicInfo: {},
      awardPicShow: false,
      awardLiveInfo: {},
      awardLiveShow: false,
      awardLivePlay: false,
      awardVideoInfo: {},
      awardVideoShow: false,
      awardVideoList: [],
      awardVideoItemInfo: {},
      awardVideoPlay: false,
      awardVideo: [],
      awardVideoIndex: 0,

      awardList2: [],
      awardVideoInfo2: {},
      awardVideoShow2: false,
      awardVideoList2: [],
      awardVideoItemInfo2: {},
      awardVideoPlay2: false,
      awardVideo2: [],
      awardVideoIndex2: 0,
    };
  },

  created() {

    console.log('getUrlParam scene==', getUrlParam('scene'))
    if(getUrlParam('scene')){
      this.scene = getUrlParam('scene')
    }
    console.log("scene==", this.scene)

    this.getMuseumList();
    this.getExhibitsList();
    this.getMomentList();
    this.getCloudList();
    this.getRelicList();
    this.getLevelList(156637);
    this.getLevelList(156638);
    this.getLevelInfo(157016);
    this.getLevelInfo(157017);
    this.getLevelList(157016);
    this.getLevelList(157017);
    this.getAwardList();
  },

  mounted() {
    var _this = this

    var slidesPerView = isMobile() ? 3 : 5

    this.mySwiper = new Swiper("#swiper__note", {
      slidesPerView: slidesPerView,  //这里是否可以判断 电脑显示5个，手机显示3个
      slidesPerColumn: 2,
      spaceBetween: 15,
      pagination: "#swiper__note .swiper-pagination",
      paginationClickable :true,
      observer:true,
      observeParents:true,
    });

    //定时
    setTimeout(() => {
      console.log('===slideTo===')
      this.mySwiper.slideTo(0, 50, false);
    }, 200);
  },

  methods: {
    isMobile(){
      return isMobile()
    },

    getMuseumList() {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=155695",
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            // console.log('getMuseumList===', res.body);
            if (res.body.error_code === 0) {
              this.museumList = res.body.data;
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getExhibitsList() {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=156385",
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            // console.log('getExhibitsList===', res.body);
            
            if (res.body.error_code === 0) {
              var exhibitsList = []
              for(var index in res.body.data){
                exhibitsList[index] = res.body.data[index]

                var isVote = this.$storeLocal.get('isVote_' + res.body.data[index].id)
                exhibitsList[index].isVote = isVote == 1 ? true : false;
                
                exhibitsList[index].voteNum = 0;

                var adjust = 0
                if(res.body.data[index].body.vote){
                  adjust = parseInt(res.body.data[index].body.vote)
                }
                this.getVoteNum(res.body.data[index].id, index, adjust);
              }
              this.exhibitsList = exhibitsList;

              console.log('this.exhibitsList===', this.exhibitsList)
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    vote(id, index) {
      this.$http
        .jsonp(
          "https://api.itv.cctv.com/praise/add?type=other&num=1&id=bc_" + id,
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('vote===', res.body);
            if (res.body.code === 0) {
              this.exhibitsList[index].voteNum += 1;
              this.exhibitsList[index].isVote = 1;
              this.$storeLocal.set('isVote_' + id, 1)
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getVoteNum(id, index, adjust){
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/praise/get?type=other&id=bc_" + id,
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            // console.log('getVoteNum===', res.body);
            if (res.body.code === 0) {
              this.exhibitsList[index].voteNum = res.body.data.num + adjust;
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getMomentList() {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=156380&column=156383",
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getMomentList===', res.body);
            if (res.body.error_code === 0) {
              var momentList = []
              for(var index in res.body.data){
                momentList[index] = res.body.data[index]
              }
              this.momentList = momentList;
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getCloudList() {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=156489&column=156490",
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getCloudList===', res.body);
            if (res.body.error_code === 0) {
              var cloudList = []
              for(var index in res.body.data){
                cloudList[index] = res.body.data[index]
              }
              this.cloudList = cloudList;
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getRelicList() {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=156489&column=156502",
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getRelicList===', res.body);
            if (res.body.error_code === 0) {
              var relicList = []
              for(var index in res.body.data){
                relicList[index] = res.body.data[index]
              }
              this.relicList = relicList;
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getLevelList(column) {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=156636&column=" + column,
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getLevelList===' + column + '===', res.body);
            if (res.body.error_code === 0) {
              this.levelLongList[column] = res.body.data;
              var levelShortList = []
              for(var index in res.body.data){
                if(index < this.levelShortNum){
                  levelShortList[index] = res.body.data[index];
                }
              }
              this.levelShortList[column] = levelShortList
              this.open(column);
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getLevelInfo(column) {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/detail?id=" + column,
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getLevelInfo===' + column + '===', res.body);
            if (res.body.error_code === 0) {
              this.levelInfo[column] = res.body.data;
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getAwardList() {
      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?config=156967",
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getAwardList===', res.body);
            if (res.body.error_code === 0) {
              for(var index in res.body.data){
                if(this.scene == 0 && res.body.data[index].body.edition == 1){
                  continue;
                }

                if(res.body.data[index].body.position == 2){
                  if(res.body.data[index].body.type == 1){
                    // this.awardLiveInfo = res.body.data[index].body
                    // this.awardLiveShow = true
                  }else if(res.body.data[index].body.type == 2){
                    this.awardList2.push(res.body.data[index])

                    this.awardVideoInfo2 = res.body.data[index].body
                    this.awardVideoShow2 = true
                    this.getAwardVideoList2(res.body.data[index].id)
                  }else if(res.body.data[index].body.type == 3){
                    // this.awardPicInfo = res.body.data[index].body
                    // this.awardPicShow = true
                  }
                }else{
                  this.awardList.push(res.body.data[index])

                  if(res.body.data[index].body.type == 1){
                    this.awardLiveInfo = res.body.data[index].body
                    this.awardLiveShow = true
                  }else if(res.body.data[index].body.type == 2){
                    this.awardVideoInfo = res.body.data[index].body
                    this.awardVideoShow = true
                    this.getAwardVideoList(res.body.data[index].id)
                  }else if(res.body.data[index].body.type == 3){
                    this.awardPicInfo = res.body.data[index].body
                    this.awardPicShow = true
                  }
                }
              }

              console.log('this.awardList==', this.awardList)
              if(this.awardLiveShow){
                //定时
                setTimeout(() => {
                  console.log('===setTimeout===')
                  this.livePlayer(this.awardLiveInfo.address, this.awardLiveInfo.image)
                }, 500);
              }
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getAwardVideoList(column) {
      var _this = this

      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=156969&column=" + column,
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getAwardVideoList===', res.body);
            if (res.body.error_code === 0) {
              this.awardVideoList = res.body.data;
              if(res.body.data.length > 0){
                this.awardVideoItemInfo = res.body.data[0].body
              }
              console.log("this.awardVideoList==", this.awardVideoList)

              var videoSlidesPerView = isMobile() ? 3 : 4.5

              _this.myVideoSwiper = new Swiper("#swiper__videoTab", {
                slidesPerView: videoSlidesPerView,  //这里是否可以判断 电脑显示4.5个，手机显示3个
                spaceBetween: 15,
                prevButton: "#swiper__videoTab .swiper-button-prev",
                nextButton:"#swiper__videoTab .swiper-button-next",
                observer:true,
                observeParents:true,
                onClick: function(swiper){
                  console.log("swiper.clickedIndex==", swiper.clickedIndex)
                  if(swiper.clickedIndex >= 0){
                    _this.awardVideoItemInfo = _this.awardVideoList[swiper.clickedIndex].body
                    _this.awardVideoDoPlay()
                  }
                },
              });

              //定时
              setTimeout(() => {
                console.log('===slideTo===')
                _this.myVideoSwiper.slideTo(0, 50, false);

                // console.log("_this.myVideoSwiper.slides[0]====", _this.myVideoSwiper.slides[0])
                _this.myVideoSwiper.slides.eq(0).addClass('active')
              }, 200);

              $("#swiper__videoTab").on("click",".swiper-slide",function(){
                $(this).toggleClass("active", true);
                $(this).siblings().toggleClass("active", false);
              })
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    getAwardVideoList2(column) {
      var _this = this

      this.$http
        .jsonp(
          "https://common.itv.cctv.com/cms/list?page=1&limit=500&config=156969&column=" + column,
          { jsonp: "jsonp_callback" }
        )
        .then(
          function(res) {
            console.log('getAwardVideoList2===', res.body);
            if (res.body.error_code === 0) {
              this.awardVideoList2 = res.body.data;
              if(res.body.data.length > 0){
                this.awardVideoItemInfo2 = res.body.data[0].body
              }
              console.log("this.awardVideoList2==", this.awardVideoList2)

              var videoSlidesPerView = isMobile() ? 3 : 4.5

              _this.myVideoSwiper = new Swiper("#swiper__videoTab2", {
                slidesPerView: videoSlidesPerView,  //这里是否可以判断 电脑显示4.5个，手机显示3个
                spaceBetween: 15,
                prevButton: "#swiper__videoTab2 .swiper-button-prev",
                nextButton:"#swiper__videoTab2 .swiper-button-next",
                observer:true,
                observeParents:true,
                onClick: function(swiper){
                  console.log("swiper.clickedIndex==", swiper.clickedIndex)
                  if(swiper.clickedIndex >= 0){
                    _this.awardVideoItemInfo2 = _this.awardVideoList2[swiper.clickedIndex].body
                    _this.awardVideoDoPlay2()
                  }
                },
              });

              //定时
              setTimeout(() => {
                console.log('===slideTo===')
                _this.myVideoSwiper.slideTo(0, 50, false);

                // console.log("_this.myVideoSwiper.slides[0]====", _this.myVideoSwiper.slides[0])
                _this.myVideoSwiper.slides.eq(0).addClass('active')
              }, 200);

              $("#swiper__videoTab2").on("click",".swiper-slide",function(){
                $(this).toggleClass("active", true);
                $(this).siblings().toggleClass("active", false);
              })
            }
          },
          function(error) {
            console.log("请求失败处理", error);
          }
        );
    },

    awardLiveDoPlay(){
      console.log("awardLiveDoPlay", this.awardLiveInfo.address)
      this.awardLivePlay = true
      this.livePlayer(this.awardLiveInfo.address)
    },

    awardVideoDoPlay(){
      var _this = this

      var _player_height = parseInt($(".live__box").width() * 9 / 16);  //播放器高

      $(".activ__videoBox .videobox").height(_player_height);

      var pid = '';
      if (this.awardVideoItemInfo.uuid !== "") {
        pid = this.awardVideoItemInfo.uuid
      } else {
        pid = this.awardVideoItemInfo.video
      }
      console.log("pid==", pid)
      $.ajax({
        url: 'https://vdn.apps.cntv.cn/api/getIpadVideoInfo.do?pid=' + pid,
        type: 'get',
        dataType: "jsonp",
        jsonpCallback:"getHtml5VideoData",
        success:function(data){
          var data = JSON.parse(data);
          console.log('awardVideoDoPlay getIpadVideoInfo===', data)
          if(data.ack === 'yes'){
            _this.awardVideoPlay = true
            _this.awardVideoIndex = 0
            _this.$refs.awardVideo[0].onended = function(){
              console.log('===onended===');
              if(Object.keys(_this.awardVideo).length > 0){
                console.log(_this.awardVideoIndex, _this.awardVideo);
                if(_this.awardVideo.length > _this.awardVideoIndex + 1){
                  _this.awardVideoIndex = _this.awardVideoIndex + 1
                  _this.$refs.awardVideo[0].src = _this.awardVideo[_this.awardVideoIndex].url
                  _this.$refs.awardVideo[0].play()
                }
              }
            }

            if(data.video.validChapterNum === 5){
              _this.awardVideo = data.video.chapters4
            }else if(data.video.validChapterNum === 4){
              _this.awardVideo = data.video.chapters3
            }else if(data.video.validChapterNum === 3){
              _this.awardVideo = data.video.chapters3
            }else if(data.video.validChapterNum === 2){
              _this.awardVideo = data.video.chapters2
            }else{
              _this.awardVideo = data.video.chapters
            }

            console.log("_this.$refs.awardVideo[0]===", _this.$refs.awardVideo[0])
            _this.$refs.awardVideo[0].src = _this.awardVideo[_this.awardVideoIndex].url
            _this.$refs.awardVideo[0].play()
          }
        },
        error: function(error){
          console.log('vdn error', error);
        }
      });
    },

    awardVideoDoPlay2(){
      var _this = this

      var _player_height = parseInt($(".live__box").width() * 9 / 16);  //播放器高

      $(".activ__videoBox .videobox").height(_player_height);

      var pid = '';
      if (this.awardVideoItemInfo2.uuid !== "") {
        pid = this.awardVideoItemInfo2.uuid
      } else {
        pid = this.awardVideoItemInfo2.video
      }
      console.log("pid==", pid)
      $.ajax({
        url: 'https://vdn.apps.cntv.cn/api/getIpadVideoInfo.do?pid=' + pid,
        type: 'get',
        dataType: "jsonp",
        jsonpCallback:"getHtml5VideoData",
        success:function(data){
          var data = JSON.parse(data);
          console.log('awardVideoDoPlay2 getIpadVideoInfo===', data)
          if(data.ack === 'yes'){
            _this.awardVideoPlay2 = true
            _this.awardVideoIndex2 = 0
            _this.$refs.awardVideo2[0].onended = function(){
              console.log('===onended===');
              if(Object.keys(_this.awardVideo2).length > 0){
                console.log(_this.awardVideoIndex2, _this.awardVideo2);
                if(_this.awardVideo2.length > _this.awardVideoIndex2 + 1){
                  _this.awardVideoIndex2 = _this.awardVideoIndex2 + 1
                  _this.$refs.awardVideo2[0].src = _this.awardVideo2[_this.awardVideoIndex2].url
                  _this.$refs.awardVideo2[0].play()
                }
              }
            }

            if(data.video.validChapterNum === 5){
              _this.awardVideo2 = data.video.chapters4
            }else if(data.video.validChapterNum === 4){
              _this.awardVideo2 = data.video.chapters3
            }else if(data.video.validChapterNum === 3){
              _this.awardVideo2 = data.video.chapters3
            }else if(data.video.validChapterNum === 2){
              _this.awardVideo2 = data.video.chapters2
            }else{
              _this.awardVideo2 = data.video.chapters
            }

            console.log("_this.$refs.awardVideo2[0]===", _this.$refs.awardVideo2[0])
            _this.$refs.awardVideo2[0].src = _this.awardVideo2[_this.awardVideoIndex2].url
            _this.$refs.awardVideo2[0].play()
          }
        },
        error: function(error){
          console.log('vdn error', error);
        }
      });
    },

    open(column) {
      if(this.levelOpen[column]){
        this.levelOpen[column] = false
        this.levelList[column] = this.levelShortList[column]
      }else{
        this.levelOpen[column] = true
        this.levelList[column] = this.levelLongList[column]
      }
    },

    show(index, type = 1) {
      var _this = this

      console.log('type===', type);
      var pid = '';
      if (type == 1) {
        pid = this.momentList[index].body.video
      } else if (type == 2) {
        pid = this.cloudList[index].body.video
      } else if (type == 3) {
        pid = this.relicList[index].body.video
      }

      $.ajax({
        url: 'https://vdn.apps.cntv.cn/api/getIpadVideoInfo.do?pid=' + pid,
        type: 'get',
        dataType: "jsonp",
        jsonpCallback:"getHtml5VideoData",
        success:function(data){
          var data = JSON.parse(data);
          console.log('getIpadVideoInfo===', data)
          if(data.ack === 'yes'){
            _this.videoIndex = 0
            _this.$refs.video.onended = function(){
              console.log('===onended===');
              if(Object.keys(_this.video).length > 0){
                console.log(_this.videoIndex, _this.video);
                if(_this.video.length > _this.videoIndex + 1){
                  _this.videoIndex = _this.videoIndex + 1
                  _this.$refs.video.src = _this.video[_this.videoIndex].url
                  _this.$refs.video.play()
                }
              }
            }

            if(data.video.validChapterNum === 3){
              _this.video = data.video.chapters3
            }else if(data.video.validChapterNum === 2){
              _this.video = data.video.chapters2
            }else{
              _this.video = data.video.chapters
            }
            console.log("_this.$refs.video=====", _this.$refs.video)
            _this.$refs.video.src = _this.video[_this.videoIndex].url
            _this.$refs.video.play()
            $(".modal").show();
            $("body").addClass('lock');
          }
        },
        error: function(error){
          console.log('vdn error', error);
        }
      });
    },
    
    close() {
      this.$refs.video.pause()
      $(".modal").hide();
      $("body").removeClass('lock');
      this.video = {}
      this.videoIndex = 0
    },

    wxShare() {
      console.log('===wxShare===')
      if(this.wxShareDispaly === "none;"){
        this.wxShareDispaly = "block;"
      }else{
        this.wxShareDispaly = "none;"
      }
    },

    qqShare(){
      var title = '“博潮”首届博物馆青年文创联名大会';
      var contents = '创新方式讲文物，设计之笔秀文物。带上你的创意Idea快来加入吧！';
      var pic = 'https://static.itv.cctv.com/2020bochao/img/share1.jpg';
      var link = 'https://itv.cctv.com/html/2020bochao/index.html';

      window.open('http://connect.qq.com/widget/shareqq/index.html?url=' 
        + link + '&sharesource=qzone&title=' 
        + title + '&pics=' 
        + pic + '&summary=' 
        + contents + '&desc=' + contents);
    },

    qzoneShare(){
      var title = '“博潮”首届博物馆青年文创联名大会';
      var contents = '创新方式讲文物，设计之笔秀文物。带上你的创意Idea快来加入吧！';
      var pic = 'https://static.itv.cctv.com/2020bochao/img/share1.jpg';
      var link = 'https://itv.cctv.com/html/2020bochao/index.html';

      window.open('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' 
        + link + '&sharesource=qzone&title=' 
        + title + '&pics=' 
        + pic + '&summary=' + contents);
    },

    livePlayer(_channel, _poster_img = ""){
      var _player_width = "100%";  //播放器宽
      var _player_height = parseInt($(".live__box").width() * 9 / 16);  //播放器高

      $(".activ__videoBox .videobox").height(_player_height);

      var _player_type = "live";

      //移动端设置宽高，也可以自己定义宽高
      if(isIPad()) {
        _player_type = "hw";

        _player_width = parseInt($(".live__box").width());
      }

      var playerParas = {
        divId: "flash_video",   /*播放器容器id，必填项*/
        w: _player_width,   /*播放器宽度，必填项*/
        h: _player_height,   /*播放器高度，必填项*/
        t: _channel,   /*台名称，比如cctv1,cctv13等，必填项*/
		
        st: "",   /*回看或时移的开始时间，也可以用秒表示的10位时间戳*/
        et: "",  /*回看或时移的结束时间.如果是时移，该参数可以为空*/
        isAutoPlay: "true",   /*是否自动播放，只有false为不自动播放，其它值为自动播放。该参数设置为false或posterImg有值，则都不自动播放*/
        ruleVisible: "false",   /*是否显示时移尺子，默认true表示显示*/
        br: "",  /*设置默认码率*/
        posterImg: _poster_img,   /*播放器前贴图片*/
        isLive4k: "false",  /*是否为4k播放器，true是4k,false不是*/
        isHttps: "true",  /*是否https视频，true是,false不是*/
        wmode: "opaque",   /*flash播放器的窗口模式，默认为opaque*/
        hasBarrage: "false",  /*是否有弹幕功能，默认false，false时不显示弹幕、不显示弹幕设置按钮、不显示弹幕开关、不访问弹幕接口和表情包配置接口e*/
        playerType : _player_type, /*播放器类型，small表示小窗播放器*/
        webFullScreenOn: "true",   /*是否显示网页全屏按钮，默认true表示显示*/
        isLeftBottom: "false",  /*播放按钮是否在播放器左下角,为true表示是，false表示播放按钮在播放器中间*/
      };

      createLivePlayer(playerParas);
    }
  }
};
</script>
